import type { OutputField } from '../utils/bakeoffFields';

/**
 * One bake-off output as labeled plain-text blocks, identical layout for every model.
 * Bookkeeping fields show only when showAll is on. A reply that was cut off or
 * malformed shows the fields it could recover plus one plain notice line, never raw text.
 */
export function BakeoffOutput({ fields, showAll, malformed = false }: { fields: OutputField[]; showAll: boolean; malformed?: boolean }) {
  const visible = showAll ? fields : fields.filter((f) => !f.bookkeeping);
  return (
    <div className="bk-output">
      {malformed && <p className="bk-notice">Reply was cut off or malformed</p>}
      {visible.map((f) => (
        <div key={f.key} className="bk-field">
          <div className="bk-field-label">{f.label}</div>
          <div className="bk-field-value">{f.text || '(not given)'}</div>
        </div>
      ))}
    </div>
  );
}
